import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';

import FormComponent from './FormComponent';
import * as action from '../../actions';
import * as selector from '../../selectors';

const dateFormat = 'YYYY-MM-DD HH:mm:ss';
const timeFormat = 'HH:mm';
const dateInThePast = new Date('1970-01-01');
const dateInTheFuture = new Date('2100-01-01');

const mapStateToProps = state => {
	return {
		uuid: selector.getAppUuid(state),
		form: selector.getBookForm(state),
		tables: selector.getTables(state),
		selectedTableId: selector.getSelectedTableId(state),
		selectedIntervals: selector.getSelectedIntervals(state),
		settings: selector.getSettings(state),
	};
};
const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		book: action.book.request,
		unselectAll: action.unselectAll,
	}, dispatch);
};

@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		uuid: PropTypes.string,
		settings: PropTypes.object,
		tables: PropTypes.object,
		date: PropTypes.string,
		selectedTableId: PropTypes.number,
		selectedIntervals: PropTypes.array,
		form: PropTypes.object,
		book: PropTypes.func,
		unselectAll: PropTypes.func,
	};

	onSubmit = (props, onFailure) => {
		const send = new Promise((resolve, reject) => {
			this.props.book({
				form: {
					...props,
					device: this.props.uuid,
					source: 'website',
				},
				resolve,
				reject,
			});
		});
		send.then(() => {
			document.getElementsByClassName('theme')[0].scrollTop = 0;
		}).catch((error) => {
			console.error('Error occurred:', error);
			onFailure && onFailure();
		});
	};

	onClose = () => {
		this.props.unselectAll();
	}

	render() {
		const {
			settings: {interval, cards_only},
			tables,
			selectedTableId,
			selectedIntervals,
			form: {loading},
		} = this.props;

		const containerClassName = "reservation shadow-lg p-4";

		const someSelected = selectedIntervals.length;
		if (!someSelected) {
			return (
				<div className={`${containerClassName} hide`} />
			);
		}

		const minDate = selectedIntervals.reduce((minDate, interval) => {
			return interval.date.getTime() < minDate.getTime()
				? interval.date
				: minDate;
		}, dateInTheFuture);
		const maxDate = selectedIntervals.reduce((maxDate, interval) => {
			return interval.date.getTime() > maxDate.getTime()
				? interval.date
				: maxDate;
		}, dateInThePast);

		const momentFrom = moment(minDate);
		const momentTill = moment(maxDate).add({minutes: interval});

		const initialValues = {
			table_id: selectedTableId,
			booked_from: momentFrom.format(dateFormat),
			booked_till: momentTill.format(dateFormat),
		};

		const selectedTable = tables.get('list').toJS().find(table => table.id === selectedTableId);
		const timeFrom = momentFrom.format(timeFormat);
		const timeTill = momentTill.format(timeFormat);

		return (
			<div className={containerClassName}>
				<div className="container-fluid">
					<div className="row">
						<div className="col-xl-10 offset-xl-1">
							<FormComponent
								tableName={selectedTable.name}
								timeFrom={timeFrom}
								timeTill={timeTill}
								loading={loading}
								initialValues={initialValues}
								cardsOnly={!!Number(cards_only)}
								onSubmit={this.onSubmit}
							/>
						</div>
					</div>
				</div>
				<div className="close" onClick={this.onClose} title="Отменить" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/book/BookForm.js